import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Table } from "reactstrap";
import { translateHCATypeEnumValue } from "helpers/translateHardcodedData";
import { hca_type_types } from "helpers/listsHardcodedData";
import * as endpoints from "constants/endpoints";
import { GetData } from "../../helpers/CRUD.js";
import { str2bool } from "../../helpers/utils.js";
import IconCheck from "../Common/IconCheck";
import IconX from "../Common/IconX";
import i18next from "i18next";

const TableHCATypes = (props) => {
  const [state, setState] = useState({
    equipmentManufacturers: [],
  });

  const handleDataChange = (event) => {
    const value = event.target.value;

    setState((state) => ({
      ...state,
      [event.target.name]: value,
    }));

    props.data[event.target.name] = value;
  };

  const handleEdit = () => {
    setState((state) => ({ ...state, mode: "edit" }));
  };

  const handleSave = () => {
    setState((state) => ({ ...state, mode: "view" }));
  };

  const toggleRadioModule = (e) => {
    setState((state) => ({
      ...state,
      hasRadioModule: str2bool(e.target.value),
    }));

    props.data.hasRadioModule = str2bool(e.target.value);
  };

  const toggleActive = (e) => {
    setState((state) => ({ ...state, isActive: str2bool(e.target.value) }));

    props.data.isActive = str2bool(e.target.value);
  };

  const getEquipmentManufacturers = () => {
    const url = `${endpoints.NOMENCLATURE_ENDPOINT}/EquipmentManufacturer/GetAllByDeviceType?deviceType=Разпределители`;

    GetData(
      url,
      (data) => {
        setState((state) => ({ ...state, equipmentManufacturers: data }));
      },
      (error) => console.log(error)
    );
  };

  useEffect(() => {
    setState((state) => ({ ...state, ...props.data }));
    getEquipmentManufacturers();
  }, []);

  const radioStyle = {
    listStyle: "none",
    paddingLeft: "0",
  };
  const labelStyle = {
    paddingLeft: "20px",
  };

  const tableStyle = {
    tableLayout: "fixed",
  };

  const {
    id,
    name,
    equipmentManufacturerId,
    equipmentManufacturer,
    model,
    type,
    hasRadioModule,
  } = props.data;

  const typeValue = translateHCATypeEnumValue(type);
  const hca_type_types_list = hca_type_types();

  return (
    <>
      <div className="table-responsive">
        <Table className="table-nowrap mb-0" style={tableStyle}>
          <tbody>
            <tr>
              <th>{i18next.t("name")}</th>

              <td>
                {props.mode === "edit" ? (
                  <input
                    name="name"
                    placeholder={i18next.t("placeholder_enter_name")}
                    id="hca_type_name"
                    onChange={(e) => handleDataChange(e)}
                    defaultValue={name}
                    className="w-100 input-styled"
                  />
                ) : (
                  name
                )}
              </td>
            </tr>

            <tr>
              <th>{i18next.t("manufacture")}</th>

              <td>
                {props.mode === "edit" ? (
                  <select
                    name="equipmentManufacturerId"
                    id="hca_type_еquipment_manufacturer"
                    onChange={(e) => handleDataChange(e)}
                    value={equipmentManufacturerId}
                    className="w-100 input-styled"
                  >
                    <option
                      value="0"
                      selected={equipmentManufacturerId === "" ? true : false}
                    >
                      {i18next.t("select_equipment_manufacturer")}
                    </option>
                    {state.equipmentManufacturers.length > 0 &&
                      state.equipmentManufacturers.map(
                        (еquipmentManufacturer) => (
                          <option
                            key={`option-${еquipmentManufacturer.id}`}
                            value={еquipmentManufacturer.id}
                            selected={
                              equipmentManufacturerId ===
                              еquipmentManufacturer.id
                                ? true
                                : false
                            }
                          >
                            {еquipmentManufacturer.name}
                          </option>
                        )
                      )}
                  </select>
                ) : (
                  props.data.equipmentManufacturer &&
                  props.data.equipmentManufacturer.name
                )}
              </td>
            </tr>

            <tr>
              <th>{i18next.t("model")}</th>

              <td>
                {props.mode === "edit" ? (
                  <input
                    name="model"
                    placeholder={i18next.t("placeholder_enter_model")}
                    id="hca_type_model"
                    onChange={(e) => handleDataChange(e)}
                    defaultValue={model}
                    className="w-100 input-styled"
                  />
                ) : (
                  model
                )}
              </td>
            </tr>

            <tr>
              <th>{i18next.t("type")}</th>

              <td>
                {props.mode === "edit" ? (
                  <select
                    name="type"
                    id="hca_type_type"
                    onChange={(e) => handleDataChange(e)}
                    value={type}
                    className="w-100 input-styled"
                  >
                    <option value="" selected={type === "" ? true : false}>
                      {i18next.t("select_type")}
                    </option>
                    {hca_type_types_list &&
                      hca_type_types_list.length > 0 &&
                      hca_type_types_list.map((type) => (
                        <option
                          value={type.key}
                          selected={type === type.key ? true : false}
                        >
                          {type.value}
                        </option>
                      ))}
                  </select>
                ) : (
                  typeValue
                )}
              </td>
            </tr>

            <tr>
              <th>{i18next.t("radioModuleNumber")}</th>

              <td>
                {props.mode === "edit" ? (
                  <div>
                    <div className="radio">
                      <label>
                        <input
                          type="radio"
                          value="true"
                          checked={hasRadioModule === true}
                          onChange={(e) => toggleRadioModule(e)}
                        />
                        {i18next.t("yes")}
                      </label>
                    </div>

                    <div className="radio">
                      <label>
                        <input
                          type="radio"
                          value="false"
                          checked={hasRadioModule === false}
                          onChange={(e) => toggleRadioModule(e)}
                        />
                        {i18next.t("no")}
                      </label>
                    </div>
                  </div>
                ) : (
                  [
                    hasRadioModule === true ? (
                      <span key={`${id}-0`}>{i18next.t("yes")}</span>
                    ) : (
                      <span key={`${id}-1`}>{i18next.t("no")}</span>
                    ),
                  ]
                )}
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
    </>
  );
};

TableHCATypes.propTypes = {
  userProfile: PropTypes.any,
  onGetUserProfile: PropTypes.func,
};

const mapStateToProps = ({ contacts }) => ({
  userProfile: contacts.userProfile,
});

const mapDispatchToProps = (dispatch) => ({
  onGetUserProfile: () => dispatch(getUserProfile()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(TableHCATypes));
